module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_lines-f0a8dbd340573be3e9a95e9a2069f894.gif";